const NALLogin = () => null;

export default NALLogin;
